// src/cryptoData.js

const cryptoData = {
  US: {
    companies: [
      { name: "Spearbit", url: "https://www.spearbit.com" },
      { name: "Coinbase", url: "https://www.coinbase.com" },
      { name: "Kraken", url: "https://www.kraken.com" },
      { name: "Gemini", url: "https://www.gemini.com" },
      { name: "Circle", url: "https://www.circle.com" },
      { name: "BlockFi", url: "https://www.blockfi.com" },
      { name: "Chainalysis", url: "https://www.chainalysis.com" },
      { name: "Ripple", url: "https://ripple.com" },
      { name: "Paxos", url: "https://paxos.com" },
      { name: "BitGo", url: "https://www.bitgo.com" },
      { name: "Anchorage Digital", url: "https://www.anchorage.com" },
      { name: "Alchemy", url: "https://www.alchemy.com" },
      { name: "Consensys", url: "https://consensys.net" },
      { name: "OpenSea", url: "https://opensea.io" },
      { name: "Uniswap Labs", url: "https://uniswap.org" },
      { name: "Paradigm", url: "https://www.paradigm.xyz" },
      { name: "a16z Crypto", url: "https://a16zcrypto.com" },
      { name: "FalconX", url: "https://falconx.io" },
      { name: "Fireblocks", url: "https://www.fireblocks.com" },
      { name: "TRM Labs", url: "https://www.trmlabs.com" },
      { name: "Compound Labs", url: "https://compound.finance" },
      { name: "Arbitrum", url: "https://arbitrum.io" },
      { name: "Optimism", url: "https://www.optimism.io" },
      { name: "Yuga Labs", url: "https://www.yuga.com" },
      { name: "Robinhood Crypto", url: "https://robinhood.com/crypto" },
      { name: "Blockchain Capital", url: "https://blockchain.capital" },
      { name: "Digital Currency Group", url: "https://dcg.co" },
      { name: "Galaxy Digital", url: "https://www.galaxy.com" },
      { name: "Grayscale", url: "https://grayscale.com" },
      { name: "MetaMask", url: "https://metamask.io" },
      { name: "Nansen", url: "https://www.nansen.ai" },
    ],
  },
  JP: {
    companies: [
      { name: "bitFlyer", url: "https://bitflyer.com" },
      { name: "Coincheck", url: "https://www.coincheck.com" },
      { name: "GMO Coin", url: "https://coin.z.com" },
      { name: "SBI VC Trade", url: "https://www.sbivc.co.jp" },
      { name: "Bitbank", url: "https://bitbank.cc" },
      { name: "DMM Bitcoin", url: "https://bitcoin.dmm.com" },
    ],
  },
  GB: {
    companies: [
      { name: "Aztec", url: "https://aztec.network" },
      { name: "Aave", url: "https://aave.com" },
      { name: "Euler", url: "https://euler.finance" },
      { name: "rhinestone", url: "https://rhinestone.wtf" },
      { name: "argent", url: "https://www.argent.xyz" },
      { name: "hyperlane", url: "https://www.hyperlane.xyz" },
      { name: "wintermute", url: "https://www.wintermute.com" },
      { name: "pumpdotfun", url: "https://pump.fun" },
      { name: "Blockchain.com", url: "https://www.blockchain.com" },
      { name: "Copper", url: "https://copper.co" },
      { name: "Elliptic", url: "https://www.elliptic.co" },
    ],
  },
  DE: {
    companies: [
      { name: "Bitstamp", url: "https://www.bitstamp.net" },
      { name: "Blockchain.com", url: "https://www.blockchain.com" },
      { name: "Nuri", url: "https://nuri.com" },
      { name: "Bitpanda", url: "https://www.bitpanda.com" },
      { name: "Unstoppable Finance", url: "https://unstoppable.finance" },
      { name: "Pendulum", url: "https://pendulum.chain" },
      { name: "Peaq", url: "https://www.peaq.network" },
      { name: "Energy Web", url: "https://www.energyweb.org" },
      { name: "Composable Finance", url: "https://www.composable.finance" },
      { name: "Holochain", url: "https://www.holochain.org" },
      { name: "Kapilendo", url: "https://www.kapilendo.de" },
      { name: "Tangany", url: "https://tangany.com" },
      { name: "Coinify", url: "https://www.coinify.com" },
      { name: "Upvest", url: "https://upvest.co" },
      { name: "Finoa", url: "https://www.finoa.io" },
      { name: "Blocksize Capital", url: "https://www.blocksize-capital.com" },
      { name: "Iconic Holding", url: "https://iconicholding.com" },
      { name: "Bitbond", url: "https://www.bitbond.com" },
      { name: "Centrifuge", url: "https://centrifuge.io" },
      { name: "Validity Labs", url: "https://validitylabs.org" },
      { name: "DIA", url: "https://www.diadata.org" },
      { name: "Gnosis", url: "https://gnosis.io" },
      { name: "Brainbot", url: "https://brainbot.com" },
      { name: "Polkadot Berlin", url: "https://polkadot.network" },
    ],
  },
  CH: {
    companies: [
      { name: "ethereum", url: "https://ethereum.org" },
      { name: "0xPolygonFdn", url: "https://polygon.technology" },
      { name: "AragonProject", url: "https://aragon.org" },
      { name: "Dune", url: "https://dune.com" },
      { name: "CurveFinance", url: "https://curve.fi" },
      { name: "gelatonetwork", url: "https://gelato.network" },
      { name: "ArrakisFinance", url: "https://www.arrakis.finance" },
      { name: "anoma", url: "https://anoma.net" },
      { name: "LiquityProtocol", url: "https://www.liquity.org" },
      { name: "SteakhouseFi", url: "https://steakhouse.financial" },
      { name: "21Shares", url: "https://21shares.com" },
      { name: "Bitcoin Suisse", url: "https://www.bitcoinsuisse.com" },
      { name: "Sygnum", url: "https://www.sygnum.com" },
    ],
  },
  AE: {
    companies: [
      { name: "biconomy", url: "https://www.biconomy.io" },
      { name: "AvailProject", url: "https://availproject.org" },
      { name: "0xfluid", url: "https://www.fluid.finance" },
      { name: "bybit", url: "https://www.bybit.com" },
      { name: "SpheronFDN", url: "https://spheron.network" },
      { name: "beradigm_xyz", url: "https://beradigm.xyz" },
      { name: "forma", url: "https://www.forma.xyz" },
      { name: "Polytrade_fin", url: "https://polytrade.finance" },
      { name: "0xPolygon", url: "https://polygon.technology" },
      { name: "heliuslabs", url: "https://helius.xyz" },
      { name: "auroraisnear", url: "https://aurora.dev" },
      { name: "pStakeFinance", url: "https://pstake.finance" },
      { name: "SOCKETProtocol", url: "https://socket.tech" },
      { name: "CopperxHQ", url: "https://copperx.io" },
    ],
  },
  SG: {
    companies: [
      { name: "Crypto.com", url: "https://crypto.com" },
      { name: "Coinhako", url: "https://www.coinhako.com" },
      { name: "Tokenize Xchange", url: "https://tokenize.exchange" },
      {
        name: "Independent Reserve",
        url: "https://www.independentreserve.com",
      },
      { name: "Triple A", url: "https://triple-a.io" },
    ],
  },
  KR: {
    companies: [
      { name: "Upbit", url: "https://upbit.com" },
      { name: "Bithumb", url: "https://www.bithumb.com" },
      { name: "Korbit", url: "https://www.korbit.co.kr" },
      { name: "Gopax", url: "https://www.gopax.co.kr" },
      { name: "Coinone", url: "https://coinone.co.kr" },
    ],
  },
  HK: {
    companies: [
      { name: "BC Technology Group", url: "https://bc.group" },
      { name: "HashKey Group", url: "https://www.hashkey.com" },
      { name: "Amber Group", url: "https://www.ambergroup.io" },
      { name: "Genesis Block", url: "https://www.genesisblock.com" },
    ],
  },
  CA: {
    companies: [
      { name: "Coinsquare", url: "https://coinsquare.com" },
      { name: "Newton", url: "https://www.newton.co" },
      { name: "NDAX", url: "https://ndax.io" },
      { name: "Netcoins", url: "https://netcoins.ca" },
      { name: "Shakepay", url: "https://shakepay.com" },
    ],
  },
  AU: {
    companies: [
      { name: "CoinJar", url: "https://www.coinjar.com" },
      {
        name: "Independent Reserve",
        url: "https://www.independentreserve.com",
      },
      { name: "BTC Markets", url: "https://www.btcmarkets.net" },
      { name: "Swyftx", url: "https://swyftx.com" },
      { name: "Digital Surge", url: "https://digitalsurge.com.au" },
    ],
  },
  BR: {
    companies: [
      { name: "Mercado Bitcoin", url: "https://www.mercadobitcoin.com.br" },
      { name: "Foxbit", url: "https://foxbit.com.br" },
      { name: "NovaDAX", url: "https://www.novadax.com.br" },
      { name: "Bitcoin Market", url: "https://www.bitcointrade.com.br" },
      { name: "Bitso Brazil", url: "https://bitso.com/br" },
      { name: "PagCripto", url: "https://pagcripto.com.br" },
      { name: "BitcoinToYou", url: "https://www.bitcointoyou.com" },
      { name: "CoinEx", url: "https://www.coinext.com.br" },
      { name: "Binance Brazil", url: "https://www.binance.com/pt-BR" },
    ],
  },
  ZA: {
    companies: [
      { name: "Luno", url: "https://www.luno.com/za" },
      { name: "VALR", url: "https://www.valr.com" },
      { name: "AltCoinTrader", url: "https://www.altcointrader.co.za" },
      { name: "ChainEX", url: "https://chainex.io" },
      { name: "Ice3X", url: "https://ice3x.co.za" },
      { name: "Ovex", url: "https://www.ovex.io" },
      { name: "Coindirect", url: "https://www.coindirect.com" },
      { name: "YellowCard", url: "https://yellowcard.io/za" },
      { name: "Revix", url: "https://revix.com" },
      { name: "XAGO", url: "https://xago.io" },
    ],
  },
  FR: {
    companies: [
      { name: "Ledger", url: "https://www.ledger.com" },
      { name: "Sorare", url: "https://sorare.com" },
      { name: "Coinhouse", url: "https://www.coinhouse.com" },
      { name: "Just Mining", url: "https://just-mining.com" },
      { name: "LGO", url: "https://www.lgo.group" },
      { name: "Kaiko", url: "https://www.kaiko.com" },
      { name: "iExec", url: "https://iex.ec" },
      { name: "Nomadic Labs", url: "https://www.nomadic-labs.com" },
      { name: "Coinify France", url: "https://www.coinify.com" },
      { name: "Paymium", url: "https://www.paymium.com" },
      { name: "Request Network", url: "https://request.network" },
      { name: "Lydia", url: "https://lydia-app.com" },
      { name: "Flowdesk", url: "https://www.flowdesk.com" },
      { name: "ACINQ", url: "https://acinq.co" },
      { name: "Starton", url: "https://www.starton.com" },
      { name: "Paraswap", url: "https://paraswap.io" },
      { name: "Morpho Labs", url: "https://morpho.xyz" },
      { name: "Angle Protocol", url: "https://angle.money" },
    ],
  },
  ES: {
    companies: [
      { name: "Bit2Me", url: "https://bit2me.com" },
      { name: "Bitnovo", url: "https://www.bitnovo.com" },
      { name: "InbestMe", url: "https://inbestme.com" },
      { name: "Criptan", url: "https://www.criptan.com" },
      { name: "Debitum Network", url: "https://www.debitum.network" },
    ],
  },
};

export default cryptoData;
